/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { memo, useEffect } from "react";
import {useFormContext, useWatch} from "react-hook-form";
import { isEmpty } from "utilities/string";

/**
 * アコーディオン内のチェックボックス
 * @param {String} id checkbox id
 * @param {String} name react-hook-form管理用フォーム特定文字列
 * @param {String} ymd yyyyMMdd
 * @param {Boolean} disabled true :非活性
 *                           false:活性
 * @param {String} children カレンダー表示アイコン「○」「×」
 * @param {String} rules バリデーション設定オブジェクト
 * @param {Object} kbuHmDayInfo カレンダー情報
 * @param {Number} page ページ情報
 */
const CalendarCheckBox = memo(({ id, name, ymd, disabled, children, rules, kbuHmDayInfo, page, setNoCapacity }) => {
  const {
    register,
    setValue,
    getValues,
  } = useFormContext();

  // カレンダー表示の監視
  const changeCapacityInfo = useWatch({
    name: "changeCapacityInfo",
    defaultValue: "",
  });

  useEffect(() => {
    checkBoxSelectOnlyOne(name);
    // チェックボックス初期チェック
    if (kbuHmDayInfo.selectedPage !== undefined) {
      // appointmentYmd とappointmentHmTimeCdがセットされていない場合、未チェック
      if (!(kbuHmDayInfo.appointmentYmd === "" && kbuHmDayInfo.appointmentHmTimeCd === "")) {
        document.getElementById("time" + kbuHmDayInfo.appointmentYmd + "_" + kbuHmDayInfo.appointmentHmTimeCd).checked = true;
        document.getElementById("time" + kbuHmDayInfo.appointmentYmd + "_" + kbuHmDayInfo.appointmentHmTimeCd).parentElement.style.backgroundColor = "#3359cc";
        document.getElementById("time" + kbuHmDayInfo.appointmentYmd + "_" + kbuHmDayInfo.appointmentHmTimeCd).nextElementSibling.children[0].style.borderColor = "#fff";
      }
      setValue("appointmentYmd", kbuHmDayInfo.appointmentYmd, { shouldValidate: true, })
      setValue("appointmentHmTimeCd", kbuHmDayInfo.appointmentHmTimeCd, { shouldValidate: true, });
    }
  }, []);

  useEffect(() => {
    // チェック状態を全てクリア
    clearAllCheckBox(name);
    // 表示ページに選択値が存在していたら、チェック
    const checkedItem = document.getElementById("time" + getValues("appointmentYmd") + "_" + getValues("appointmentHmTimeCd"));
    if (checkedItem != null) {
      // 選択済み日付帯時間帯が〇/×チェック
      if (checkedItem.disabled) {
        // 選択済み日付帯時間帯が×の場合　setNoCapacityをtrueにする(呼び出し元で選択状態を解除、選択値を空、メッセージ表示、ボタンを非活性)
        if (changeCapacityInfo){
          setNoCapacity(true);
        }
      } else {
        // 選択済み日付帯時間帯が〇の場合選択状態にする
        checkedItem.checked = true;
        checkedItem.parentElement.style.backgroundColor = "#3359cc";
        checkedItem.nextElementSibling.children[0].style.borderColor = "#fff";
        setNoCapacity(false);
      }
    }
  }, [changeCapacityInfo]);

  return (
    <>
      <input
        type="checkbox"
        onClick={(e) => {
          // チェックボックス一つだけ選択可能
          checkBoxSelectOnlyOne(name);

          // チェック状態で背景色・文字色を判定
          if (e.target.checked) {
            // クリックしたセルの値を詰め、Validate実施
            setValue("appointmentYmd", e.target.dataset.ymd, { shouldValidate: true, })
            setValue("appointmentHmTimeCd", e.target.id.split('_')[1], { shouldValidate: true, });
            e.target.parentElement.style.backgroundColor = "#3359cc";
            e.target.nextElementSibling.children[0].style.borderColor = "#fff";
          } else {
            // 空文字を詰め、Validate実施
            setValue("appointmentYmd", "", { shouldValidate: true, })
            setValue("appointmentHmTimeCd", "", { shouldValidate: true, });
            e.target.parentElement.style.backgroundColor = "";
            e.target.nextElementSibling.children[0].style.borderColor = "#004098";
          }
        }}
        {...register(name, {
          ...rules,
          validate: {
            isChecked: () => {

              // 表示ページ問わず、ご希望日時が選択されている場合はボタン非活性
              if (!isEmpty(getValues("appointmentYmd")) && !isEmpty(getValues("appointmentHmTimeCd"))) {
                return true;
              }

              if (isChecked(name) === true) {
                return true;
              } else {
                return false;
              }
            }
          },
        })}
        id={id}
        name={name}
        data-ymd={ymd}
        disabled={disabled}
      />
      <label htmlFor={id}>{children}</label>
    </>
  );
});

/**
 * チェックボックスがチェックされているか判定
 * @returns true:引数で渡されたname属性にチェックあり
 *          false:引数で渡されたname属性にチェックなし
 */
const isChecked = (name) => {
  const checkArr = document.getElementsByName(name);
  var result = false;
  checkArr.forEach(element => {
    if (element.checked === true) {
      result = true;
    }
  });
  return result;
}

/**
 * チェックボックスで一つだけ選択
 * @param {*} name チェックボックス群のname
 */
const checkBoxSelectOnlyOne = (name) => {
  const checkGet = document.getElementsByName(name);
  checkGet.forEach((check) => {
    check.parentElement.style.backgroundColor = "";
    check.nextElementSibling.children[0].style.borderColor = "#004098";
    check.addEventListener("click", () => {
      if (check.checked) {
        checkGet.forEach((allChecks) => {
          allChecks.checked = false;
        });
        check.checked = true;
      }
    });
  });
}

/**
 * チェックボックス一括クリア
 * @param {*} name チェックボックスのname
 */
const clearAllCheckBox = (name) => {
  const checkGet = document.getElementsByName(name);
  checkGet.forEach((check) => {
    check.parentElement.style.backgroundColor = "";
    check.nextElementSibling.children[0].style.borderColor = "#004098";
    check.checked = false;
  });
}

export default CalendarCheckBox;
